import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./containers/App";
import * as serviceWorker from "../src/registerServiceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import dotenv from "dotenv";

// Load environment variables from .env.local
const environment = process.env.REACT_APP_ENV || "local";
dotenv.config({ path: `environments/.env.${environment}` });

//  import 'ie11-scroll-into-view';

ReactDOM.render(<App />, document.getElementById("root"));
serviceWorker.unregister();
